import { Component, Output, Input, EventEmitter, ViewChild, ElementRef, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import monthsName from './months.json';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
})
export class CalendarComponent implements OnInit, AfterViewChecked {
  // state
  settedDefaultState = false;

  timeout: any;
  value: string = '';
  calendarVisible: boolean[] = [];
  arrayCalendar: string[][] = [[]];
  undefinedChecked: boolean;

  currentDate: Date;
  currentYear: number;
  currentMonth: number;
  currentDay: number;

  selectedYear: number;
  selectedMonth: number;
  selectedMonthName: string;
  selectedDay: string;

  displayedMonth: number;

  startOfMonth: number;
  numOfDays: number;

  yearsOptions: number[] = [];
  monthsOptions: string[] = monthsName;

  // end state

  @Input() canBeUndefined: boolean;
  @Input() defaultDate?: Date;
  @Input() controlForm: FormControl = new FormControl('');
  @Input() colorOnMovileView: 'BROWN_GREY' | 'WHITE' = 'BROWN_GREY';

  @ViewChild('calendar', { static: false }) calendarContainer: ElementRef;
  @ViewChild('input', { static: false }) input: ElementRef;
  @Output() valueEmitter = new EventEmitter<Date | undefined>();

  selectorsControl: FormGroup = new FormGroup({
    month: new FormControl(),
    year: new FormControl(),
  })

  constructor(
    private ref: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    this.canBeUndefined = false;

    this.calendarContainer = this.ref;
    this.input = this.ref;

    this.currentDate = new Date();
    this.currentYear = this.currentDate.getUTCFullYear();
    this.currentMonth = this.currentDate.getUTCMonth();
    this.currentDay = this.currentDate.getDate();

    const selectedDate = this.currentDate;

    this.selectedYear = selectedDate.getUTCFullYear();
    this.selectedMonth = selectedDate.getUTCMonth();

    this.selectorsControl.patchValue({ year: this.selectedYear, month: this.selectedMonth + 1 });

    this.displayedMonth = this.selectedMonth;
    this.selectedMonthName = monthsName[this.selectedMonth];
    this.selectedDay = '';

    this.startOfMonth = getStartOfMonth(this.selectedMonth, this.selectedYear);
    this.numOfDays = 32 - new Date(this.selectedYear, this.selectedMonth, 32).getDate();
    this.arrayCalendar = this.getArrayCalendar();

    this.undefinedChecked = false;

    // Month and year selectors

    this.yearsOptions = new Array(100).fill(1).reduce<number[]>((arr, _, index) => {
      arr.push(this.currentYear + (index + 1));
      arr.push(this.currentYear - (index + 1));
      return arr;
    }, [this.currentYear]).sort((a, b) => a - b);

    this.selectorsControl.valueChanges.subscribe((values) => {

      const newMonth = +values.month - 1;
      const newYear = +values.year;

      this.startOfMonth = getStartOfMonth(newMonth, newYear);

      this.numOfDays = 32 - new Date(newYear, newMonth, 32).getDate();

      this.arrayCalendar = this.getArrayCalendar();
    });
  }

  ngOnInit() {
    if (this.defaultDate !== undefined) {

      let selectedDate = this.currentDate;

      if (this.defaultDate !== undefined && this.defaultDate !== null) {
        if (!isValidDate(this.defaultDate)) {
          selectedDate = new Date(<string><unknown>this.defaultDate);
        }
        else {
          selectedDate = this.defaultDate;
        }
      }

      this.selectedYear = selectedDate.getUTCFullYear();
      this.selectedMonth = selectedDate.getUTCMonth();

      this.displayedMonth = this.selectedMonth;

      this.selectedMonthName = monthsName[this.selectedMonth];
      this.selectedDay = '';
      if (this.defaultDate !== undefined && this.defaultDate !== null) {
        this.selectedDay = selectedDate.getDate().toString();
      }

      this.selectorsControl.patchValue({ month: this.selectedMonth + 1, year: this.selectedYear });

      this.startOfMonth = getStartOfMonth(this.selectedMonth, this.selectedYear);
      this.numOfDays = 32 - new Date(this.selectedYear, this.selectedMonth, 32).getDate();
      this.arrayCalendar = this.getArrayCalendar();
    }
    this.controlForm.valueChanges.subscribe({
      next: (value) => {

        if (value === null) {
          this.input.nativeElement.value = '';
        }
        else if (isValidDate(value)) {
          const formatedDay = value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();
          const formatedMonth = value.getUTCMonth() + 1 < 10 ? `0${value.getUTCMonth() + 1}` : value.getUTCMonth() + 1;
          const textDate = `${formatedDay}/${formatedMonth}/${value.getUTCFullYear()}`;
          this.input.nativeElement.value = textDate;
          this.valueEmitter.emit(value);
        }
      },
    });

    this.controlForm.valueChanges.subscribe(() => {
      this.handleBlur(0);
      this.handleBlur(1);
      this.handleBlur(2);
      this.handleBlur(3);
    });
  }

  ngAfterViewChecked() {
    if (this.defaultDate !== undefined) {
      if (this.defaultDate === null && !this.settedDefaultState) {
        this.toogleUndefinedChecked();
        this.settedDefaultState = true;
      }

      if (this.defaultDate !== null && !this.settedDefaultState) {
        this.onDayClicked(+this.selectedDay);
        this.settedDefaultState = true;
      }
    }
  }

  getArrayCalendar(): string[][] {
    let array2d: string[][] = [];
    let counter = 0;

    for (let indexWeek = 0; indexWeek < 6; indexWeek++) {
      array2d[indexWeek] = [];
      for (let indexDay = 0; indexDay < 7; indexDay++) {
        counter++;
        if (counter >= this.startOfMonth && (counter - this.startOfMonth) < this.numOfDays) {
          array2d[indexWeek][indexDay] = (counter - this.startOfMonth + 1).toString();
        }
      }
    }
    return array2d;
  }

  handleBlur(elementIndex: number) {
    setTimeout(() => {
      if (elementIndex === 3) {
        // eslint-disable-next-line no-return-assign
        this.calendarVisible.map((_, index) => this.calendarVisible[index] = false);
        return;
      }
      this.calendarVisible[elementIndex] = false;
      this.cdr.detectChanges();
    }, 0);
  }

  handleFocus(elementIndex: number) {
    this.calendarVisible[elementIndex] = true;
  }

  get calendarVisibility() {
    return this.calendarVisible.some((visible) => visible);
  }

  toogleVisibility() {
    this.calendarVisible[0] = true;
    if (this.calendarVisible) {
      setTimeout(() => {
        this.calendarContainer.nativeElement.focus();
        this.calendarContainer.nativeElement.click();
      }, 10);
    }
  }

  toogleUndefinedChecked() {
    this.undefinedChecked = !this.undefinedChecked;
    if (this.undefinedChecked) {
      this.input.nativeElement.value = 'Fecha indefinida';
      this.handleBlur(0);
      this.valueEmitter.emit(undefined);
      this.controlForm.patchValue(undefined);
    }
    else if (this.selectedDay) {
      this.onDayClicked(+this.selectedDay);
    }
    else {
      this.controlForm.reset();
      this.input.nativeElement.value = '';
    }
  }

  onChangeMonth(value: number) {
    let newMonth = this.selectedMonth + value;
    let newYear = this.selectedYear;
    if (newMonth < 0) {
      newYear--;
      newMonth = 11;
    }
    else if (newMonth > 11) {
      newMonth = 0;
      newYear++;
    }

    this.startOfMonth = getStartOfMonth(newMonth, newYear);
    this.numOfDays = 32 - new Date(newYear, newMonth, 32).getDate();
    this.selectedYear = newYear;
    this.selectedMonth = newMonth;
    this.selectedMonthName = monthsName[newMonth];
    this.arrayCalendar = this.getArrayCalendar();
  }

  onDayClicked(day: number) {
    this.selectedDay = day.toString();
    const formatedDay = day < 10 ? `0${day}` : day;

    const { year, month } = this.selectorsControl.value;
    const numberMonth = +month - 1;
    const formatedMonth = numberMonth + 1 < 10 ? `0${numberMonth + 1}` : numberMonth + 1;
    const textDate = `${formatedDay}/${formatedMonth}/${year}`;

    const date = getDate(textDate);

    this.controlForm.patchValue(date);
    this.handleBlur(3);
  }

  asFormControl(control: AbstractControl): FormControl {
    return control as FormControl;
  }
}

function getDate(stringDate: string) {
  const [startDay, startMonth, startYear] = stringDate.split('/').map((val: string) => +val);
  return new Date(startYear, startMonth - 1, startDay);
}
function isValidDate(d: Date) {
  return d instanceof Date && !Number.isNaN(d);
}

function getStartOfMonth(month: number, year: number) {
  const startOfMonth = new Date(year, month).getDay();
  return startOfMonth === 0 ? 7 : startOfMonth;
}
